var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TransferHeader
 * @author zhuwanying02
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '../Checkbox/';
import { classPrefix } from '../../common/util';

var TransferHeader = function (_Component) {
    _inherits(TransferHeader, _Component);

    function TransferHeader() {
        _classCallCheck(this, TransferHeader);

        return _possibleConstructorReturn(this, (TransferHeader.__proto__ || Object.getPrototypeOf(TransferHeader)).apply(this, arguments));
    }

    _createClass(TransferHeader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                classPrefix = _props.classPrefix,
                title = _props.title,
                dataSourceLength = _props.dataSourceLength,
                selectedIdsLength = _props.selectedIdsLength,
                isSelectAll = _props.isSelectAll,
                toggleSelectAll = _props.toggleSelectAll;

            var prefixCls = classPrefix + '-transfer-list';
            return React.createElement(
                'div',
                { className: prefixCls + '-header' },
                React.createElement(
                    Checkbox,
                    {
                        control: true,
                        checked: isSelectAll,
                        getValue: toggleSelectAll
                    },
                    title
                ),
                React.createElement(
                    'span',
                    { className: prefixCls + '-count' },
                    selectedIdsLength,
                    '/',
                    dataSourceLength
                )
            );
        }
    }]);

    return TransferHeader;
}(Component);

TransferHeader.defaultProps = {
    classPrefix: classPrefix
};
TransferHeader.propTypes = {
    classPrefix: PropTypes.string,
    title: PropTypes.node,
    dataSourceLength: PropTypes.number,
    selectedIdsLength: PropTypes.number,
    isSelectAll: PropTypes.oneOf([true, false, -1]),
    toggleSelectAll: PropTypes.func
};
export default TransferHeader;